import { render, staticRenderFns } from "./locking-page.vue?vue&type=template&id=00851e7e"
import script from "./locking-page.vue?vue&type=script&lang=js"
export * from "./locking-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports